import axios from 'axios'
import { Message } from 'element-ui';
import router from './../router'

/**
 * 从 localStorage 安全读取 token
 * 兼容 JSON 格式与纯字符串（如 Bearer xxx）
 * @returns {string}
 */
function getStoredToken() {
	var raw = window.localStorage.getItem('token')
	if (!raw) return ''
	try {
		var parsed = JSON.parse(raw)
		if (parsed && parsed.data && parsed.data.obj && parsed.data.obj.token) {
			return parsed.data.obj.token
		}
		return ''
	} catch (e) {
		return raw.replace(/^Bearer\s+/i, '').trim()
	}
}

/**
 * 销售模块失效时回到新登录页，其他模块仍回原登录页
 * @returns {string}
 */
function getLoginRedirectPath() {
	var path = (router.currentRoute && router.currentRoute.path) || ''
	if (path.indexOf('/sale') === 0) {
		return '/sale/login'
	}
	return '/login'
}

/****** 创建axios实例 ******/
const service = axios.create({
	baseURL: API_BASE,
	timeout: 30000  ,// 请求超时时间
	// withCredentials: true,
 	// crossDomain: true
});
/****** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
	config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    // 登录不需要传token,看一下自己登录的接口包含哪个特殊字段
	var USER_TOKEN = getStoredToken()
	// 登录不需要传token,看一下自己登录的接口包含哪个特殊字段
	if(USER_TOKEN && !config.url.includes('login') && !config.url.includes('getToken') && !config.url.includes('usrLogin') && !config.url.includes('generateValidateCode')){
		if(config.data == ''){
			config.data ='token='+ USER_TOKEN
		}else{
			config.data +='&token='+ USER_TOKEN
		}
	}
	return config;
}, error => { //请求错误处理
	Promise.reject(error)
});

/****** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
	response => { //成功请求到数据
//		let loadingInstance = Loading.service();
//		  loadingInstance.close();
		//这里根据后端提供的数据进行对应的处理
		if(response.data.code == '101000') {
      Message.error('token失效，请重新登录！')
      localStorage.removeItem('token')
			router.replace({
          path: getLoginRedirectPath()
      });
      return
		
    }
    // else if(response.data.code == '102001'){
			// Message.error('对不起，您没有权限')
		// }
    else {
			return response;
		}
	},
	error => { //响应错误处理
		console.log(error);
		return Promise.reject(error)
	}
);
export default service;



// WEBPACK FOOTER //
// ./src/axios/request.js